import React from 'react';
import UICheckbox from 'Components/UIComponents/UICheckbox';
import {
  DocumentFieldsCRUDMeta,
  DocumentFieldUpdatePayload,
} from 'Interfaces/DocumentFields';

interface FieldRequiredProps {
  isChecked: boolean;
  onUpdateDocumentField: (
    payload: Omit<DocumentFieldUpdatePayload, 'id'>,
    meta?: DocumentFieldsCRUDMeta,
  ) => void;
}

function FieldRequired({ isChecked, onUpdateDocumentField }: FieldRequiredProps) {
  const handleCheck = () => onUpdateDocumentField({ required: !isChecked });

  return (
    <div className="fieldDropDown__checkbox">
      <UICheckbox handleClick={handleCheck} check={isChecked} label="Required" />
    </div>
  );
}

export default FieldRequired;
